<template>
	<AuthLayout title="Login">
		<div
			class="list-group-item p-4"
			v-if="!sharedState.user"
		>
			<form @submit.prevent="login">
				<div class="form-group">
					<input
						class="form-control"
						placeholder="email"
						required
						type="email"
						v-model="email"
					>
				</div>
				<div class="form-group">
					<input
						class="form-control"
						placeholder="password"
						required
						type="password"
						v-model="password"
					>
					<p class="m-2">
						<router-link to="/forgot">Forgot password</router-link>
					</p>
				</div>

				<div class="d-flex justify-content-between mt-5">
					<router-link
						class="btn btn-outline-primary"
						to="/register"
					>Register</router-link>
					<button
						class="btn btn-primary"
						type="submit"
					>Log in</button>
				</div>
			</form>
		</div>
		<div
			class="list-group-item py-4"
			v-if="!sharedState.user"
		>
			<div class="text-center">
				<a
					class="btn btn-link"
					@click="googleLogin"
					href="javascript:void(0)"
				>
				<b-icon
					font-scale="1.5"
					icon="google"
				/> Or you can log in via Google</a>
			</div>
		</div>
		<div
			class="align-items-center d-flex list-group-item"
			v-else
		>
			<b-avatar
				class="mr-3"
				variant="primary"
				:src="(sharedState.user || {}).imageUrl"
			/>
			<div
				class="flex-grow-1"
				v-if="sharedState.user"
			>
				{{ sharedState.user.name }}
				<br>
				<small>{{ sharedState.user.email }}</small>
			</div>
			<div>
				<button
					class="btn btn-danger"
					@click="logout()"
				>Sign Out</button>
			</div>
		</div>
		<div
			class="align-items-center d-flex list-group-item"
			v-if="sharedState.user && !sharedState.user.verified"
		>
			<b-avatar
				class="mr-3"
				variant="warning"
			>
				<b-icon
					font-scale="1.5"
					icon="exclamation"
				/>
			</b-avatar>
			<div>
				<strong>Your account needs verification.</strong>
				<br>
				Please contact the administrators and be patient!
			</div>
		</div>
	</AuthLayout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'
import auth from '@/auth'

export default {
	components: { AuthLayout },
	data() {
		return {
			email: null,
			password: null,
		}
	},
	methods: {
		googleLogin() {
			auth.resetAuthMessages()
			this.sharedState.googleAuth.signIn()
                        console.log(this.sharedState.googleAuth)
		},
		async login() {
			auth.resetAuthMessages()
			this.sharedState.loading = true
			const { email, password } = this
			try {
				await auth.submitLoginForm(email, password)
				this.email = null
				this.password = null
			} catch (error) {
				this.sharedState.authError = error
			} finally {
				this.sharedState.loading = false
			}
		},
		logout() {
			auth.logout()
		},
	},
	async mounted() {
		this.sharedState.loading = true
		await auth.init()
		this.sharedState.loading = false
	},
}
</script>
